<template>
  <div class="bg-gray">
   <navigation-bar />
    <div class="container-fluid">
      <h1 class="text-left" style="margin-top:20px;">Confirm Email</h1>
      <p class="text-left">{{store.state.message}}</p>
    </div>
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
import NavigationBar from "../nav/NavigationBar";
import DashboardFooter from "../nav/Footer";
import Utils from "@/Utils/Utils";
import Navigator from "@/router/navigator";
import ConfirmEmailStore from "./ConfirmEmailStore";
import AccountSessionUtils from "./AccountSessionUtils";
import moment from "moment";

export default {
  name: "ConfirmEmail",
  components: {
    NavigationBar,
    DashboardFooter
  },
  data() {
    return {
      nav: Navigator,
      store: ConfirmEmailStore,
      accountUtils: AccountSessionUtils,
      utils: Utils
    };
  },
  mounted() {
    this.store.reset();
    this.accountUtils.authorize(
      userId => {
        this.store.state.currentUserId = userId;
        this.confirmEmail();
      },
      err => {
        this.$toasted.show(err, { type: "error", duration: 2500 });
      }
    );
  },
  computed: {},
  methods: {
    confirmEmail() {
      var token = "";
      let searchParts = window.location.search.split("=");
      if (searchParts.length > 1) {
        token = searchParts[1];
      }

      this.store.confirmEmail(
        token,
        data => {
          this.$forceUpdate();
        },
        err => {
          this.$forceUpdate();
          this.$toasted.show(err, { type: "error", duration: 2500 });
        },
        () => {
          this.nav.goMaintenance(this);
        }
      );
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.favorite-item {
  background: white;
  border-radius: 10px;
  padding: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
}
.white {
  color: white;
}

a {
  color: #ff6f5e;
}
</style>



// WEBPACK FOOTER //
// src/components/account/ConfirmEmail.vue